import React from 'react';
import { useTranslation } from 'react-i18next';

import { Col, Row } from 'antd/lib/grid';

import { getDeviceScreenType, getMobileOperatingSystem } from '@utils/DeviceInfoUtils';

import { GlobalOutlined, MailOutlined } from '@assets/antdIcons';
import { Android, Apple, facebookIcon, instagramIcon, linkedinIcon, youtubeIcon } from "@assets/index";

import Divider from '@components/atoms/Divider';
import { Img } from '@components/Image';
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import { ANDROID_APP_ID, ANDROID_PLAYSTORE_LINK, IOS_APPSTORE, platform, Platform, UTM_CAMPAIGN, UTM_MEDIUM, UTM_SOURCE } from '@constants/config';

import qs from 'qs';
import './styles.less';

const Footer = () => {
  const { t } = useTranslation();

  const socialMedia = platform.WO ? [
    {
      id: 1,
      link: t("guestView.labelsAndTitles.FACEBOOK_LINK"),
      icon: facebookIcon,
    },
    {
      id: 2,
      link: t("guestView.labelsAndTitles.LINKEDINN_LINK"),
      icon: linkedinIcon,
    },
    {
      id: 3,
      link: t("guestView.labelsAndTitles.YOUTUBE_LINK"),
      icon: youtubeIcon,
    }
  ]: [
    {
      id: 1,
      link: t("guestView.labelsAndTitles.LINKEDINN_LINK"),
      icon: linkedinIcon,
    }
  ];

  const legalLinks = [
    {
      id: 1,
      href: t("guestView.labelsAndTitles.PRIVACY_LINK"),
      text: t("guestView.labelsAndTitles.PRIVACY")
    },
    {
      id: 2,
      href: t("guestView.labelsAndTitles.TERMS_LINK"),
      text: t("guestView.labelsAndTitles.TERMS")
    },
    {
      id: 3,
      href: t("guestView.labelsAndTitles.COOKIE_LINK"),
      text: t("guestView.labelsAndTitles.COOKIE"),
    }
  ];

  const onClickApple = () => {
    const iosAppObject = {
      utm_source: getDeviceScreenType() === 'xs' ? UTM_SOURCE.MOBILE_WEB: UTM_SOURCE.DESKTOP_WEB,
      utm_medium: UTM_MEDIUM.FOOTER,
      utm_campaign: UTM_CAMPAIGN.MOBILE_APP_INSTALL
    }
    window.location.href = `${IOS_APPSTORE}?${qs.stringify(iosAppObject)}`;
  }

  const onClickAndroid = () => {
    window.location.href = `${ANDROID_PLAYSTORE_LINK}?id=${ANDROID_APP_ID}&referrer=utm_source%3D${getDeviceScreenType() === 'xs' ? UTM_SOURCE.MOBILE_WEB: UTM_SOURCE.DESKTOP_WEB}%26utm_medium%3D${UTM_MEDIUM.FOOTER}%26utm_campaign%3D${UTM_CAMPAIGN.MOBILE_APP_INSTALL}`;
  }

  return (
    <div className="footer-container">
      <div className="footer container">
        <Row>
          <Col lg={18} xs={24}>
            
              <Text
                fontFamilyVariant={FontFamilyVariant.medium}
                text={t("guestView.labelsAndTitles.FOR_MORE_INFO")}
                textType={TextType.h8}
                className="more_info"
              />
            <div className="for-more-info">
              <a
                className="website-link"
                href={t("guestView.labelsAndTitles.WEBSITE_LINK")}
                target={"_blank"}
              >
                <GlobalOutlined />
              </a>
              <a href="mailto:wgdt@wfglobal.org" className="website-link">
                <MailOutlined />
              </a>
              {/* <a
                className="career-guidance-link"
                href={t("guestView.labelsAndTitles.CAREER_GUIDANCE_LINK")}
                target={"_blank"}
              >
                {t("guestView.labelsAndTitles.CAREER_GUIDANCE")}
              </a> */}
            </div>
          </Col>
          <Col lg={6} xs={24}>
            <div className="follow-social-media">
              <Text
                fontFamilyVariant={FontFamilyVariant.medium}
                text={t("guestView.labelsAndTitles.FOLLOW_SOCIAL_MEDIA")}
                textType={TextType.h8}
                className="follow_social_media"
              />
              <span className='follow-social-media-icon'>
                {socialMedia && socialMedia.map((media) => {
                  const { id, link, icon } = media;
                  return (
                    <a href={link} target={"_blank"} key={id}>
                      <img alt="social media icons" src={icon} className="social-media-icon" />
                    </a>
                  )
                })}
              </span>
            </div>
          </Col>
        </Row>
        <Divider className="guest-divider" />
        <Row justify="space-between" className='bottom_links_container'>
          <Col className="links" lg={9} xs={24}>
            {legalLinks && legalLinks.map((link) => {
              const { id, href, text } = link;
              return (
                <a className="legal-link" href={href} target={"_blank"} key={id}>
                  {text}
                </a>
              )
            })}
          </Col>
          <Col lg={6} xs={24}>
            <div className='apps_container'>
              <div className='apps_container_media' onClick={onClickApple}>
                <Img src={Apple} alt="Apple" />
                {t("guestView.labelsAndTitles.IOS_APP")}
              </div>
              <div  className='apps_container_media' onClick={onClickAndroid}>
                <Img src={Android} alt="Android" />
                {t("guestView.labelsAndTitles.ANDROID_APP")}
              </div>
            </div>
          </Col>
          <Col lg={9} xs={24} className="copyright">
            <Text
              fontFamilyVariant={FontFamilyVariant.medium}
              text={t("guestView.labelsAndTitles.COPYRIGHT")}
              textType={TextType.h8}
              className="copyright_text"
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Footer;
